// extracted by mini-css-extract-plugin
export default {"uploadDocBtn":"hintsManagement_uploadDocBtn__oaX6O"};